<template>
  <div class="prod-container" v-loading="loading == -1">
    <div class="page-header">
      <md-breadcrumb :dataSource="cateParents" @breadcrumbClick="breadcrumbClick"></md-breadcrumb>

      <el-input placeholder="请输入内容" size="mini" @change="loadProdList" @clear="loadProdList" :clearable="true" v-model="searchValue" class="input-with-select">
        <el-button slot="append" icon="el-icon-search" @click="loadProdList"></el-button>
      </el-input>
    </div>

    <div class="page-data">
      <div>共计<span class="total-tip">{{total}}</span>个产品</div>
    </div>
 
    <div class="prod-list-con" v-if="prods.length > 0">
      <div class="prod-list-block" v-for="prod in prods" :key="prod.ProdID">
      <card-list :data="prod">
        <template #footer>
          <div class="edit-view">
            <i class="drag-edit" title="拖拽可放置指定的目录中"><svg-drag :width="18" :height="18" fill="#ffffff"></svg-drag></i>
            <i title="删除" class="el-icon-delete" @click.prevent="del(prod)"></i>
          </div>
        </template>
      </card-list>
      </div>
      <div class="list-card-empty" v-for="item of 20" :key="`key_${item}`"></div>
    </div>
    <el-empty description="暂无收藏的产品" v-else></el-empty>

    <div class="pagination">
      <md-page :page="page" :total="total" :pageSize="pageSize" @pagecallback="pageChanged"></md-page>
    </div>
  </div>
</template>

<script>
  import {MessageBox as ElMessageBox} from "element-ui";
  //引入服务
  import {ProdFavoriteService,OpenService,DragService} from "@/service";
  import {Category,UtilService} from '@/libs'
  //引入组件
  import ProdIcon from "@/components/icon/prod-icon.vue";
  import MdPage from '@/components/md-page.vue'; 
  import CardList from '@/components/card-list.vue';
  import MdBreadcrumb from "@/components/md-breadcrumb/md-breadcrumb.vue";

  import SvgDrag from '@/components/svg/drag.vue';

  export default {
    name: "ProdList",
    props: {
      
    },
    components: {
      ProdIcon,
      MdPage,
      CardList,
      SvgDrag,
      MdBreadcrumb
    },
    data() {
      return {
        prods: [], //产品列表
        dirId: 0,
        page: 1,
        pageSize: 50,
        total: 0,
        loading: 0, //状态  -1加载中 0 未加载  1 加载完成
        searchValue:"",
        cateParents: [{DirName: '我的桌面', DirID: 0, TreeID: 0}],
      };
    },
    mounted() {
      this.loadProdList();
    },
    methods: {
      async loadProdList() {
        //加载产品列表
        this.loading = -1;
        ProdFavoriteService.getProdList(this.page, this.pageSize, this.dirId,this.searchValue || '').then(res => {
          let block_time = null;
          res.List.forEach(item => {
            item.DirID = this.dirId;
            item.CreateDate = item.CreateDate.substr(5,);
            item.ProdName = UtilService.getHighLightHtml(this.searchValue, item.ProdName);
            if (block_time && block_time == item.CreateDate) {
              item.CreateDate = '';
            } else {
              block_time = item.CreateDate;
            }
          });
          this.total = res.TotalCount;
          this.prods = res.List;
          this.loading = 1;

          this.initDrag();
        });
      },
      del(prod) {
        ElMessageBox.confirm('您确定要从我的收藏中删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ProdFavoriteService.del(prod.FavoriteID, this.dirId).then(res => {
            if (res) {
              if (this.prods.length == 1 && this.page != 1) {
                this.page--;
              }
              this.loadProdList();

              this.$parent.$refs.catalogTree.dragDataCallback({
                toId: 0,
                fromId: this.dirId,
              })
            }
          })
        }).catch(() => {
        });
      },

      dirChanged(dirId, cateParents = []) {
        this.dirId = dirId;
        this.cateParents = cateParents.reverse();
        this.loadProdList();
      },
      pageChanged(param) {
        this.page = param.page;
        this.loadProdList();
      },
      openProdDetails(prod) {
        OpenService.openProdDetails(prod.ProdID);
      },
      openCompDetails(prod) {
        OpenService.openCompDetail(prod.CompID)
      },

      breadcrumbClick(value) {
        this.$parent.$refs.catalogTree.select(`list_${value.DirID}`);
      },

      initDrag() {
        this.$nextTick(() => {
          DragService.dragToTree({
            table: document.getElementsByClassName('prod-container')[0],
            wrapper: '.prod-list-con',
            handle: ".drag-edit",
            delay: 1,
            filter: '.list-card-empty',
            primaryKey: "FavoriteID",
            datas: this.prods,
            category: Category.ProdFavorite,
            callback: this.dragCallback,
            dirCategory: Category.ProdFavoriteDir
          })
        })
      },
      dragCallback(args) {
        this.loadProdList();
        this.$parent.$refs.catalogTree.dragDataCallback({
          toId: args.treeId,
          fromId: this.dirId,
        })
      },
    }
  };
</script>

<style lang="less" scoped>

.prod-list-block {
  min-width: 150px;
  max-width: 180px;
  margin: 0 5px 10px 5px;
  flex: 1;
  border: 1px solid #d6d6d6;
  position: relative;
  &>.list-card{
    margin: 0;
    position: initial;
    height: 100%;
    border: 0 none;
    min-width: 100%;
  }
}
.page-data{
  padding: 10px 0 5px 10px;
  font-size: 14px;
  color: @text-color-call-out;
  display: flex;
  justify-content: space-between;
  .total-tip{
    color: @a-color-active;
  }
}
.prod-list-con{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 5px;
}
.pagination{
  position: sticky;
  left: 0;
  bottom: 0;
}
.prod-container{
  position: relative;
  flex: 1;
  height: calc(100vh - 53px);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.page-header{
  border-bottom: 1px solid @line-strong-color;
  position: sticky;
  top: 0;
  z-index: 2;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 16px;
  /deep/ .md-breadcrumd{
    padding: 5px;
  }
  .input-with-select{
    width: 230px;
  }
  /deep/ .el-input__inner{
    border-top-left-radius: 14px;
    border-bottom-left-radius: 14px;
  }
  /deep/ .el-input-group__append{
    border-top-right-radius: 14px;
    border-bottom-right-radius: 14px;
  }
}

.edit-view{
  position: absolute;
  right: 0;
  bottom: 65px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  opacity: 0;
  transform: translateY(26px);
  transition: all 0.4s;
  i{
    width: 26px;
    height: 26px;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .drag-edit{
    cursor: move;
  }
}
.prod-list-con{
  /deep/ .list-card:hover .edit-view{
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>
